import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FetchLineOfCreditHistory = gql`
  query LineOfCreditHistory {
    lineOfCreditHistory {
      ... on LineOfCreditHistoryError {
        code
        message
        title
      }
      ... on LineOfCreditHistorySuccess {
        sections {
          date
          items {
            disbursementAmount {
              ...money
            }
            lineOfCreditId
            originationDate
          }
        }
      }
    }
  }
  ${money}
`;

export default FetchLineOfCreditHistory;
